import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import Notiflix from "notiflix";

import {
  Input,
  Row,
  Card,
  Form,
  Col,
  Divider,
  Spin,
  Table,
  Typography,
  Layout,
  Button,
} from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../systemAdmin.config";

const { Content } = Layout;

const DetailBranchConfiguration = (props) => {
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const { state: selectedBranchConfigKey } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const { Text } = Typography;

  const [codeListId, setCodeListId] = useState({});
  const [configureLimitTableSource, setConfigurelimitTableSource] = useState([]);
  const [configureTransactionTableSource, setConfigureTransactionTableSource] = useState([]);

  useEffect(() => {
    getBranchConfigById();
  }, []);

 const getBranchConfigById = () => {
  setIsLoading(true);
  const url = apiConfig.Branchoprconfig + `/${selectedBranchConfigKey.id}`;
  const body = { session };

  BOM.FetchReqAction(body, url, (err, res) => {
    if (err) {
      BOM.AlertMsg(cnt.DANGER, err?.errors?.[0]?.defaultUserMessage);
    } else {
      const objList = res;
      setCodeListId(objList);

      //  Branch Currency Limits Table
      const limitData = objList?.branchCcyRestrConfData?.map((item) => ({
        key: item.id,
        currencyCode: item.currencyCode,
        authThresholdAmount: Number(item.authThresholdAmount).toLocaleString(),
        transactionLimit: Number(item.transactionLimit).toLocaleString(),
      })) || [];

      // Branch Transaction Limits Table (flattened from nested structure)
      const transactionData = objList?.branchCcyRestrConfData?.flatMap((item) =>
        item.branchOperationTransactionTypeData?.map((tx) => ({
          key: tx.id,
          currencyCode: item.currencyCode,
          transactionTypeValue: tx.transactionType?.name || "N/A",
          transactionTypeLimit: Number(tx.transactionTypeLimit).toLocaleString() || 0,
        })) || []
      );

      setConfigurelimitTableSource(limitData);
      setConfigureTransactionTableSource(transactionData);

      setIsLoading(false);
    }
  });
};



  const authFormData = [
    {
      name: "Branch",
      value: codeListId?.officeId?.name || "",
    },
    {
      name: "Till Authorization",
      value: codeListId?.allowTellerTillAuth ? "Enabled" : "Disabled",
    },
    {
      name: "Vault Authorization",
      value: codeListId?.allowVaultTillAuth ? "Enabled" : "Disabled",
    },
  ];

  const columns = {
    branchLimits: [
      {
        key: "1",
        title: "Currency",
        dataIndex: "currencyCode",
      },
      {
        key: "2",
        title: "Authorization Threshold",
        dataIndex: "authThresholdAmount",
      },
      {
        key: "3",
        title: "Daily Transaction Limit",
        dataIndex: "transactionLimit",
      },
    ],
    transactionLimits: [
      {
        key: "1",
        title: "Currency",
        dataIndex: "currencyCode",
      },
      {
        key: "2",
        title: "Transaction Type",
        dataIndex: "transactionTypeValue",
      },
      {
        key: "3",
        title: "Transaction Type Limit",
        dataIndex: "transactionTypeLimit",
      },
    ],
  };

  return (
    <MainLayout isEnableRightSidebar={true}>
      <TopContent
        pageTitle={labelConfig.detailBranchConfiguration}
        pageItems={staticConfig.detailBranchConfigurationBreadcrumbItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
          title={
            <Row style={{ alignContent: "center", width: "8%" }}>
              <Button
                icon={<LeftOutlined />}
                type="text"
                style={{ marginTop: "auto", marginBottom: "auto" }}
                onClick={() => navigate(-1)}
              >
                <Text style={{ fontSize: 15 }}>Back</Text>
              </Button>
            </Row>
          }
        >
          <Card
            style={{
              marginBottom: "2%",
              boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
            }}
          >
            {/* Branch Authorization */}
            <div
              style={{
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                marginBottom: 25,
              }}
            >
              <Divider orientation="left" orientationMargin="0">
                Branch Authorization
              </Divider>
              {authFormData.map((detail, index) => (
                <div
                  key={index}
                  style={{
                    border: "2px solid #F5F5F5",
                    borderRadius: 15,
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0,
                    borderBottomColor: "#E2E2E2",
                  }}
                >
                  <Row>
                    <Col
                      span={12}
                      style={{
                        backgroundColor: "#F5F5F5",
                        padding: 10,
                        borderRadius: 15,
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0,
                        borderBottomLeftRadius: 0,
                      }}
                    >
                      <Text strong>{detail.name}</Text>
                    </Col>
                    <Col span={12} style={{ padding: 10 }}>
                      <Text className="of-bold-disable-input">{detail.value}</Text>
                    </Col>
                  </Row>
                </div>
              ))}
            </div>

            {/* Branch Limits */}
            <div
              style={{
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                marginBottom: 25,
              }}
            >
              <Divider orientation="left" orientationMargin="0">
                Branch Limits
              </Divider>
              <Table
                pagination={false}
                columns={columns.branchLimits}
                dataSource={configureLimitTableSource}
              />
            </div>

            {/* Branch Transaction Limits */}
            <div
              style={{
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                marginBottom: 25,
              }}
            >
              <Divider orientation="left" orientationMargin="0">
                Branch Transaction Limits
              </Divider>
              <Table
                pagination={false}
                columns={columns.transactionLimits}
                dataSource={configureTransactionTableSource}
              />
            </div>
          </Card>
        </Card>
      </Spin>
    </MainLayout>
  );
};

export default DetailBranchConfiguration;
